import React, { useState, useEffect } from 'react';
import { Box, Button, Typography} from '@mui/material';
import { Drawer } from '../../common';
import { useStyles } from './styles';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import {
	OMNI,
	IN_STORE,
	ECOMMERCE,
	CANCEL,
	SAVE,
	CUSTOM_TABLE_COLUMN,
	STORE,
	ECOM,
	BOGLE_MEDIUM,
	enumToColumnNames,
	MAIN_INSIGHTS_DASHBOARD,
} from '../../constants/constant';
import {
	setIsDrawerOpen,
	setColumnPreferences,
	getUserPreferences,
} from '../../redux/actions/customTableColumnAction';
import { setIsCustomizeColOpen } from '../../redux/actions/createRuleActions';
import CustomTableMetric from './CustomTableMetric/CustomTableMetric';
import CustomTableFilter from './CustomTableFilter/CustomTableFilter';
import SearchMetric from './SearchMetric/SearchMetric';
import downloadIcon from '../../assets/SVGs/download-icon.svg';
import customizeIcon from '../../assets/SVGs/customizeIcon.svg';
import {
	containsSubString,
	arrayContains,
	getMetricFromAPIList,
	arrayEquals,
	isEmpty,
	isEmptyMetrics,
} from './utils';
import { useSelector, useDispatch } from 'react-redux';
import { UserPortalContext } from '../../context/appcontext';
import { colors } from '../../theme/color-palette';
import SnackBarWrapper from '../SnackBarWrapper/SnackBarWrapper';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@material-ui/core';
import { saveEventTrack } from '../../redux/actions/eventTrackAction';
import { setExcelDownloadAction } from '../../redux/actions/tableActions';
import analytics from '../../helper/analytics';
import tracker from '../../constants/tracker';

const CustomTableColumn = () => {
	const classes = useStyles();
	const [searchText, setSearchText] = useState('');
	const [, setAnchorEl] = useState(null);
	const columnPreferences = useSelector((state) => state.columnReducer);
	const [activeMetrics, setActiveMetrics] = useState([]);
	const [initialActiveMetrics, setInitialActiveMetrics] = useState([]);
	const [currentAPIList, setCurrentAPIList] = useState([]);
	const [isUpdated, setIsUpdated] = useState(false);
	const dispatch = useDispatch();
	const portalUserContext = React.useContext(UserPortalContext);
	const { selectedFilters } = useSelector((state) => state.salesReducer);

	// This Store flags control the Drawer & the metric accordion
	const { isDrawerOpen, isMetricsOpen } = columnPreferences;

	const setColumnPreferencesErrorCode = useSelector(
		(state) => state.columnReducer.setColumnPreferencesErrorCode
	);

	const [errorSnackbarOpen, setErrorSnackBarOpen] = useState(true);

	const [successSnackBarOpen, setSuccessSnackBarOpen] = useState(true);

	const [exportToExcelSnackbar, setExportToExcelSnackbar] = useState(false);

	const channel = selectedFilters.selectedFilter.toUpperCase();

	const getCurrentGlobalFilter = () => {
		let filter = selectedFilters.selectedFilter;
		switch (filter) {
			case STORE:
				return IN_STORE;
			case ECOM:
				return ECOMMERCE;
			default:
				return OMNI;
		}
	};

	const [filterSelection, setFilterSelection] = useState(
		getCurrentGlobalFilter()
	);

	const getCurrentAPIList = () => {
		switch (filterSelection) {
			case IN_STORE:
				return columnPreferences?.columnList?.STORE;
			case ECOMMERCE:
				return columnPreferences?.columnList?.ECOM;
			default:
				return columnPreferences?.columnList?.OMNI;
		}
	};

	const getMetrics = () => {
		setCurrentAPIList(getCurrentAPIList());
	};

	const getFilterValue = () => {
		switch (filterSelection) {
			case IN_STORE:
				return STORE;
			case ECOMMERCE:
				return ECOM;
			case OMNI:
				return OMNI;
		}
	};

	const getPreference = () => {
		if (isEmpty(columnPreferences?.userPreferenceList)) {
			return [];
		}
		const filter = getFilterValue();
		let preference;
		switch (filter) {
			case STORE:
				preference = columnPreferences?.userPreferenceList?.STORE;
				break;
			case ECOM:
				preference = columnPreferences?.userPreferenceList?.ECOM;
				break;
			case OMNI:
				preference = columnPreferences?.userPreferenceList?.OMNI;
		}
		return preference;
	};

	const getAllColumns = (filter) => {
		let tempList = [];
		let columnsArr = columnPreferences?.columnList;
		if (isEmpty(columnsArr)) {
			return [];
		}
		columnsArr[filter].forEach((metric) => {
			let metrics = [];
			metric?.metrics.forEach((value) => {
				metrics.push({
					id: value?.id,
					name: enumToColumnNames[value?.name],
					shortName: value?.shortName,
				});
			});
			tempList.push({ id: metric?.id, name: metric?.name, metrics: metrics });
		});
		return tempList;
	};

	const lookupUserPreferences = () => {
		let filter = getFilterValue();
		const preference = getPreference();
		if (isEmpty(preference)) {
			setActiveMetrics(getAllColumns(filter.toUpperCase()));
			setIsUpdated(true);
		} else {
			setActiveMetrics(preference);
			setIsUpdated(false);
		}
		setInitialActiveMetrics(preference);
	};

	const openDrawer = () => {
		dispatch(setIsCustomizeColOpen(true));
		setFilterSelection(getCurrentGlobalFilter());
		closeMenu();
		getMetrics();
		getUserPreferences();
		lookupUserPreferences();
		// Open the Drawer via reducer action
		dispatch(setIsDrawerOpen(true));
	};

	const closeDrawer = () => {
		dispatch(setIsCustomizeColOpen(false));
		closeMenu();
		// Close the Drawer via reducer action
		dispatch(setIsDrawerOpen(false));
	};

	const updateActiveMetrics = (name, metric, checked, segment_id) => {
		const filter = getFilterValue();
		let tempList;
		if (
			activeMetrics == undefined ||
			isEmpty(activeMetrics) ||
			isEmptyMetrics(activeMetrics)
		) {
			tempList = [];
		} else {
			tempList = [...activeMetrics];
		}
		if (
			(tempList?.length === 0 || !arrayContains(activeMetrics, name)) &&
			checked
		) {
			let metricArr = [];
			metricArr.push(
				getMetricFromAPIList(
					currentAPIList,
					name,
					enumToColumnNames[metric],
					filter
				)
			);
			tempList.push({ name: name, id: segment_id, metrics: metricArr });
		} else {
			tempList = tempList?.map((segment) => {
				if (segment?.name?.toLowerCase() != name?.toLowerCase()) {
					return segment;
				}
				if (
					(segment?.name?.toLowerCase() === name?.toLowerCase() &&
						arrayContains(segment?.metrics, enumToColumnNames[metric])) ||
					!checked
				) {
					return {
						...segment,
						metrics: segment.metrics.filter(
							(item) =>
								enumToColumnNames[item?.shortName]?.toLowerCase() !=
								enumToColumnNames[metric]?.toLowerCase()
						),
					};
				} else {
					return {
						...segment,
						metrics: [
							...segment.metrics,
							getMetricFromAPIList(
								currentAPIList,
								name,
								enumToColumnNames[metric],
								filter
							),
						],
					};
				}
			});
		}
		setActiveMetrics(tempList);

		let doUpdate =
			(isEmptyMetrics(tempList) && !checked) ||
			arrayEquals(tempList, initialActiveMetrics);
		// In first time user flow the Save btn should not disable on metric's unselect. InitialActiveMetrics will be empty in this case.
		if (isEmptyMetrics(initialActiveMetrics)) {
			doUpdate = false;
		}

		if (doUpdate) {
			setIsUpdated(false);
		} else {
			setIsUpdated(true);
		}
	};

	const buildSegments = () => {
		let list = [];
		let index;
		for (index = 0; index < activeMetrics?.length; index++) {
			let name = activeMetrics[index]?.name;
			let mainSegmentId = activeMetrics[index]?.id;
			list.push({
				id: mainSegmentId,
				name: name,
				metrics: activeMetrics[index].metrics,
			});
		}
		return list;
	};

	const generateFilterPayload = (filter) => {
		switch (filter) {
			case OMNI:
				return [
					{
						channels: {
							OMNI: buildSegments(),
							STORE: columnPreferences?.userPreferenceList?.STORE,
							ECOM: columnPreferences?.userPreferenceList?.ECOM,
						},
					},
				];
			case ECOM:
				return [
					{
						channels: {
							OMNI: columnPreferences?.userPreferenceList?.OMNI,
							STORE: columnPreferences?.userPreferenceList?.STORE,
							ECOM: buildSegments(),
						},
					},
				];

			case STORE:
				return [
					{
						channels: {
							OMNI: columnPreferences?.userPreferenceList?.OMNI,
							STORE: buildSegments(),
							ECOM: columnPreferences?.userPreferenceList?.ECOM,
						},
					},
				];
		}
	};

	const generatePayload = () => {
		const filter = getFilterValue();
		return {
			request: {
				insightPreferences: generateFilterPayload(filter),
			},
			portalUserContext,
			userSelectedChannel: filter.toUpperCase(),
		};
	};

	const saveMetrics = () => {
		let list = generatePayload();
		dispatch(setColumnPreferences(list));
		setSearchText('');
		closeDrawer();
		setIsUpdated(false);
		const request = {
			event: 'SAVE',
			event_description: `Tabular View - ${channel} - Saved Metrics`,
			attributes: MAIN_INSIGHTS_DASHBOARD,
		};
		dispatch(saveEventTrack({ request, portalUserContext }));
		analytics.trackEventInfo({
			type: tracker.EVENTS.CLICK,
			actionOn: `Tabular View - Save Metrics`,
		});
	};

	const closeMenu = () => {
		setAnchorEl(null);
	};

	const filterCallback = (childData) => {
		setFilterSelection(childData);
	};

	const arrayContainsCharacter = (string_arr, character) => {
		let index;
		for (index = 0; index < string_arr.length; index++) {
			if (
				containsSubString(
					enumToColumnNames[string_arr[index]['shortName']],
					character
				)
			) {
				return true;
			}
		}
		return false;
	};

	useEffect(() => {
		lookupUserPreferences();
	}, [filterSelection, searchText]);

	useEffect(() => {
		setCurrentAPIList(getCurrentAPIList());
	});

	const downloadExcel = () => {
		const request = {
			event: 'DOWNLOADS',
			event_description: `Tabular View - ${channel}`,
			attributes: MAIN_INSIGHTS_DASHBOARD,
		};
		dispatch(saveEventTrack({ request, portalUserContext }));
		dispatch(setExcelDownloadAction(true));
		closeMenu();
		analytics.trackEventInfo({
			type: tracker.EVENTS.CLICK,
			actionOn: `Tabular View - Download to Excel`,
		});
	};

	const closeErrorSnackBar = () => {
		setErrorSnackBarOpen(false);
	};

	const closeSuccessSnackBar = () => {
		setSuccessSnackBarOpen(false);
	};

	const errorAction = (
		<React.Fragment>
			<IconButton
				size="small"
				aria-label="close"
				color="inherit"
				fontSize="14px"
				onClick={closeErrorSnackBar}>
				<CloseIcon fontSize="small" />
			</IconButton>
		</React.Fragment>
	);

	const successAction = (
		<React.Fragment>
			<IconButton
				size="small"
				aria-label="close"
				color="inherit"
				fontSize="14px"
				onClick={closeSuccessSnackBar}>
				<CloseIcon fontSize="small" />
			</IconButton>
		</React.Fragment>
	);

	const closeExportToExcelSnackBar = () => {
		setExportToExcelSnackbar(false);
	};

	const tryAgainExportToExcel = () => {
		setExportToExcelSnackbar(false);
		downloadExcel();
	};

	const exportToExcelErrorAction = (
		<React.Fragment>
			<Button
				className={classes.tryAgainButton}
				onClick={tryAgainExportToExcel}>
				<Typography className={classes.tryAgainText}>Try again</Typography>
			</Button>
			<IconButton
				size="small"
				aria-label="close"
				color="inherit"
				fontSize="14px"
				onClick={closeExportToExcelSnackBar}>
				<CloseIcon fontSize="small" />
			</IconButton>
		</React.Fragment>
	);

	return (
		<>
			<Box sx={{ display: 'flex', paddingLeft: '10px' }}>
				<Box
					data-test-id="columnOptionsMenu"
					className={classes.table_columnTableButton}
					onClick={downloadExcel}>
					<img alt="Download" src={downloadIcon} />
			
				</Box>
				<Box
					data-test-id="columnOptionsMenu"
					className={classes.table_columnTableButton}
					onClick={openDrawer}>
					<img alt="customizeIcon" src={customizeIcon} />
				</Box>
			</Box>

			<Drawer
				open={isDrawerOpen}
				onClose={closeDrawer}
				className={classes.table_customDrawer}
				width={360}>
				<Box className={classes.table_container}>
					<Box className={classes.table_headerBackground}>
						{/* Header */}
						<Box className={classes.table_header}>
							<Box className={classes.table_backBtnContainer}>
								<Box className={classes.table_iconBackground}>
									<ArrowBackIosNewIcon
										className={classes.table_backBtn}
										onClick={closeDrawer}
									/>
								</Box>
								<Box className={classes.table_headerText}>
									{CUSTOM_TABLE_COLUMN}
								</Box>
							</Box>
						</Box>

						{/* Toolbar */}
						<CustomTableFilter
							filter={filterSelection}
							parentCallback={filterCallback}
						/>

						{/* Search Metric */}
						<Box className={classes.table_searchContainer}>
							<SearchMetric
								searchText={searchText}
								setSearchText={setSearchText}
								disabled={false}
							/>
						</Box>
					</Box>

					{/* Categories */}
					<Box
						id="custom-table-column"
						className={classes.table_metricContainer}>
						{currentAPIList != null && currentAPIList != undefined
							? Object.keys(currentAPIList)?.map((index) => {
									if (
										((currentAPIList[index] != undefined &&
											currentAPIList[index]['name'] != undefined &&
											searchText == '') ||
											(searchText != '' &&
												arrayContainsCharacter(
													currentAPIList[index]['metrics'],
													searchText
												))) &&
										currentAPIList[index].metrics.length > 0
									) {
										return (
											<CustomTableMetric
												key={index}
												index={parseInt(index)}
												defaultOpen={isMetricsOpen}
												parentCallback={updateActiveMetrics}
												segment_id={currentAPIList[index]['id']}
												name={currentAPIList[index]['name']}
												metrics={currentAPIList[index]['metrics']}
												channel={filterSelection}
												searchText={searchText}
											/>
										);
									}
							  })
							: null}
					</Box>

					{/* Buttons */}
					<Box className={classes.table_footerButtons}>
						<Box className={classes.table_buttonBox}>
							<Button
								data-test-id="save-metrics"
								className={classes.table_buttonSave}
								sx={{
									textTransform: 'capitalize',
									backgroundColor: !isUpdated
										? `${colors.PURPLE_INACTIVE}`
										: `${colors.PURPLE}`,
									borderRadius: '50px',
									'&:hover': {
										backgroundColor: `${colors.PURPLE_ACTIVE}`,
									},
								}}
								onClick={saveMetrics}
								disabled={!isUpdated}>
								<Typography
									className={classes.table_buttonSaveText}
									sx={{
										fontFamily: `${BOGLE_MEDIUM}`,
										fontSize: '16px',
									}}>
									{SAVE}
								</Typography>
							</Button>
						</Box>
						<Box className={classes.table_buttonBox}>
							<Button
								className={classes.table_buttonCancel}
								data-test-id="cancel-metrics"
								sx={{
									textTransform: 'capitalize',
									backgroundColor: `${colors.WHITE} !important`,
									border: `1px solid ${colors.PURPLE} !important`,
									borderRadius: '50px',
								}}
								onClick={closeDrawer}>
								<Typography
									className={classes.table_buttonCancelText}
									sx={{
										fontFamily: `${BOGLE_MEDIUM}`,
										fontSize: '16px',
									}}>
									{CANCEL}
								</Typography>
							</Button>
						</Box>
					</Box>
				</Box>
			</Drawer>
			{setColumnPreferencesErrorCode > 200 && (
				<SnackBarWrapper
					variant={'error'}
					open={errorSnackbarOpen}
					hideDuration={5000}
					message={'Custom Table Column Selections Not Saved'}
					action={errorAction}
					onClose={closeErrorSnackBar}
				/>
			)}
			{setColumnPreferencesErrorCode == 200 && (
				<SnackBarWrapper
					variant={'success'}
					open={successSnackBarOpen}
					hideDuration={5000}
					message={'Custom Table Column Selections Saved'}
					action={successAction}
					onClose={closeSuccessSnackBar}
				/>
			)}
			<SnackBarWrapper
				variant={'error'}
				open={exportToExcelSnackbar}
				hideDuration={5000}
				message={`Can't export to Excel.`}
				action={exportToExcelErrorAction}
				onClose={closeExportToExcelSnackBar}
			/>
		</>
	);
};

export default CustomTableColumn;
